import { z } from 'zod';

const lineTotal = (lines: { quantity: number; unitPrice: number }[]) =>
  lines.reduce((sum, line) => sum + line.quantity * line.unitPrice, 0);

/**
 * What raising a call's invoice asks: how it will be paid and what it
 * charges, each line as POST /calls/:id/invoice takes it. The server
 * refuses an invoice of $0, so the schema says so first, under the charges.
 */
export const createInvoiceSchema = z.object({
  payment: z.enum(['CARD', 'CASH']).default('CARD'),
  lines: z
    .array(
      z.object({
        description: z.string(),
        quantity: z.number(),
        unitPrice: z.number(),
      })
    )
    .min(1, 'Add a charge first')
    .refine((lines) => lineTotal(lines) > 0, {
      message: 'The invoice totals $0. Add a charge with a price.',
    }),
});

export type CreateInvoiceValues = z.infer<typeof createInvoiceSchema>;
